export const timeInSeconds = {
    minute: 60,
    hour: 3600,
    day: 86400,
    week: 604800,
}